import { Injectable, inject } from '@angular/core';
import { FormArray } from '@angular/forms';
import { combinationConverter } from '@seu-converter';
import { RequestService, StoreService } from '@seu-services';
import {
  SEU_API_ENDPOINTS,
  SeuComputationCombination,
  SeuComputationCombinationApi,
  SeuFormGroupCalculation,
} from '@seu-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ComputationCombinationService {
  private readonly requestService = inject(RequestService);
  private readonly store = inject(StoreService);

  public async saveComputationCombinations(
    offerId: string,
    formArray: FormArray<SeuFormGroupCalculation>
  ): Promise<void> {
    const computationCombinations: SeuComputationCombinationApi[] =
      formArray.value.map((formGroup) => {
        return {
          // convert to number
          interconnectionId: formGroup.interconnectionVersion
            ? Number(formGroup.interconnectionVersion)
            : null,
          globalParameterSetId: formGroup.globalSettings
            ? Number(formGroup.globalSettings)
            : null,
          operatingConditionIds: formGroup.operatingConditions
            ? formGroup.operatingConditions.map((operatingCondition) =>
                Number(operatingCondition)
              )
            : [],
        };
      });

    const endpoint = SEU_API_ENDPOINTS.calculationCombinations.replace(
      ':offerId',
      offerId
    );

    const response = await firstValueFrom(
      this.requestService.put<
        SeuComputationCombinationApi[],
        SeuComputationCombinationApi[]
      >(endpoint as SEU_API_ENDPOINTS, computationCombinations)
    );

    const combinations = response.map((combination) => {
      return combinationConverter.fromApi(combination);
    });

    this.store.setComputationCombinations(combinations);
  }

  public async loadComputationCombinations(
    offerId: string
  ): Promise<SeuComputationCombination[]> {
    const endpoint = SEU_API_ENDPOINTS.calculationCombinations.replace(
      ':offerId',
      offerId
    );

    const responseData = await firstValueFrom(
      this.requestService.get<SeuComputationCombinationApi[]>(
        endpoint as SEU_API_ENDPOINTS
      )
    );

    return responseData.map((computationCombination) => {
      return combinationConverter.fromApi(computationCombination);
    });
  }
}
